<router-outlet *ngIf="!isLoggedIn" />
<app-dashboard-layout *ngIf="isLoggedIn"></app-dashboard-layout>

<p-toast />
